import en from "../i18n/en.json";
import type { AppointmentKey } from "../i18n";

/** Every code an appointment server action can return in `ActionResult.error`. */
export type ActionErrorCode =
  | "NOT_FOUND"
  | "NOT_AUTHED"
  | "NOT_ALLOWED"
  | "INVALID_ID"
  /** Picked date malformed, not after today, or past the horizon. */
  | "INVALID_DATE"
  | "SAP_ERROR"
  | "SAP_REJECTED";

/** The `en.json` groups that map error codes to copy; each has a `default`. */
export type ErrorSurface =
  | "gate.errors"
  | "slots.errors"
  | "slots.loadErrors"
  | "cancel.errors"
  | "dashboard.errors"
  | "order.errors";

const SURFACES: Record<ErrorSurface, Record<string, string>> = {
  "gate.errors": en.gate.errors,
  "slots.errors": en.slots.errors,
  "slots.loadErrors": en.slots.loadErrors,
  "cancel.errors": en.cancel.errors,
  "dashboard.errors": en.dashboard.errors,
  "order.errors": en.order.errors,
};

/**
 * The translation key for an action error on a given surface: the
 * code-specific entry when `en.json` has one, else the surface's `default`.
 * Typed against the JSON so a surface without a `default` fails `tsc`.
 */
export function errorKey(surface: ErrorSurface, code: string): AppointmentKey {
  const table = SURFACES[surface];
  const entry = code && Object.hasOwn(table, code) ? code : "default";
  return `${surface}.${entry}` as AppointmentKey;
}
